import { AnalyticsFeatureEvent } from '@shared/models/analytics/AnalyticsFeatureEventType';
import { useState } from 'react';
import { createContainer } from 'unstated-next';

function useAnalyticsTrackingContainer() {
    const [eventHandlers, setEventHandlers] = useState<((eventName: string, data: { [key: string]: any }) => any)[]>(
        []
    );
    const addEventHandler = (handler: (eventName: AnalyticsFeatureEvent, data: { [key: string]: any }) => any) => {
        setEventHandlers([...eventHandlers, handler]);
    };
    const removeEventHandler = (handler: (eventName: AnalyticsFeatureEvent, data: { [key: string]: any }) => any) => {
        setEventHandlers(eventHandlers.filter((x) => x !== handler));
    };
    const trackEvent = async (eventName: AnalyticsFeatureEvent, data: { [key: string]: any }) => {
        for (const handler of eventHandlers) {
            await handler(eventName, data);
        }
    };
    return {
        trackEvent,
        addEventHandler,
        removeEventHandler,
    };
}

const AnalyticsTrackingContainer = createContainer(useAnalyticsTrackingContainer);
export default AnalyticsTrackingContainer;
